import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSignOutAlt, faSignInAlt} from '@fortawesome/free-solid-svg-icons';
import {Nav} from 'react-bootstrap';
import {keycloak} from '../../../data-access/reusable/keycloak';
import {useAuth} from './auth-context';
import {useConfirm} from '@zvne/fe-framework/dist/presentation/confirm/confirm';
import {useStrings} from '@zvne/fe-framework/dist/presentation/language/strings';
import {strings} from './strings';

export function LoginLogoutButton() {
    const s = useStrings(strings);
    const confirm = useConfirm();
    const auth = useAuth();

    const handleLoginClick = () => {
        keycloak.login();
    };
    const handleLogoutClick = () => confirm({
        body: <p>{s.logoutConfirm}</p>
    }).then(() => keycloak.logout());

    return (
        <Nav.Link
            onClick={auth.isAuthenticated ? handleLogoutClick : handleLoginClick}
            title={auth.isAuthenticated ? s.logout : s.login}
        >
            <FontAwesomeIcon icon={auth.isAuthenticated ? faSignOutAlt : faSignInAlt}/>
            &nbsp;
            {auth.isAuthenticated ? auth.username : s.login}
        </Nav.Link>
    );
}
